__turbopack_context__.v({
  "my_list_viewing_history": "MyListViewingHistory-module-scss-module__oYdWSG__my_list_viewing_history",
  "my_list_viewing_history_user_prompt": "MyListViewingHistory-module-scss-module__oYdWSG__my_list_viewing_history_user_prompt",
});
